export const matches = [
  {
    destination: ["https://www.oraquinto.com/fincontinuo"],
    match: {
      region: [
        "basilicata",
        "campania",
        "veneto",
        "emiliaromagna",
        "piemonte",
        "toscana",
        "trentino",
        "marche",
        "sardegna",
      ],
      category: ["retired", "military", "public_employee", "private_employee"],
    },
  },
  {
    destination: ["https://www.oraquinto.com/prestito"],
    match: {
      region: [
        "abruzzo",
        "calabria",
        "fvg",
        "lazio",
        "liguria",
        "lombardia",
        "molise",
        "puglia",
        "sicilia",
        "umbria",
        "valledaosta",
      ],
      category: ["retired", "military", "public_employee", "private_employee"],
    },
  },
];

export const fallbackUrl = null;
